import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  AwardTypeListItem,
  BannerTierformMode,
  ConfigBannerTierListItem,
  FormMode,
} from 'src/app/modules/Profile/types/agent-profile-types';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';

import { LayoutSplashScreen } from 'src/app/layout';
import { getAwardTypeById } from 'src/app/modules/Profile/network/agentProfileCrud';
import UploadAwardTypeForm from './UploadAwardTypeForm';

const BannerTierDetailPage: FC<RouteComponentProps> = ({ history }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode } = useMemo(
    () => ({
      formMode: id ? BannerTierformMode.EDIT : BannerTierformMode.CREATE,
    }),
    [id],
  );
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [awardTypeItem, setAwardTypeItem] = useState<AwardTypeListItem>();

  const reloadData = async () => {
    try {
      if (id) {
        setIsLoading(true);
        try {
          const data = await getAwardTypeById(id, dispatch);

          setAwardTypeItem(data);
        } catch (err) {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [id]);

  return (
    <>
      {formMode === BannerTierformMode.CREATE && (
        <>
          <UploadAwardTypeForm formMode={FormMode.CREATE} />
        </>
      )}
      {formMode === BannerTierformMode.EDIT &&
        (isLoading || !awardTypeItem ? (
          <LayoutSplashScreen />
        ) : (
          <>
            <UploadAwardTypeForm formMode={FormMode.EDIT} uploadAwardDetail={awardTypeItem} />
          </>
        ))}
    </>
  );
};

export default BannerTierDetailPage;
